
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill indigo-100",attrs:{"d":"M12 19h6a1 1 0 001-1v-1.789a4 4 0 00-.672-2.219l-.656-.984a4 4 0 01-.672-2.22V7.404A5 5 0 0015.123 3.5L12 1v18z"}}),_c('path',{staticClass:"fill white",attrs:{"d":"M12 1L8.877 3.499A5 5 0 007 7.403v3.386a4 4 0 01-.672 2.219l-.656.984A4 4 0 005 16.212V18a1 1 0 001 1h6V1z"}}),_c('path',{staticClass:"fill indigo-900",attrs:{"d":"M8.5 15.5a.5.5 0 01.5.5v2H8v-2a.5.5 0 01.5-.5zm7 0a.5.5 0 01.5.5v2h-1v-2a.5.5 0 01.5-.5zM8.5 21a.5.5 0 01.5.5v1a.5.5 0 01-1 0v-1a.5.5 0 01.5-.5zm3.5 0a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zm3.5 0a.5.5 0 01.5.5v1a.5.5 0 01-1 0v-1a.5.5 0 01.5-.5z"}}),_c('path',{staticClass:"fill indigo-300",attrs:{"d":"M13 7a1 1 0 11-2 0 1 1 0 012 0z"}}),_c('path',{staticClass:"fill indigo-900",attrs:{"d":"M14 7a2 2 0 11-4 0 2 2 0 014 0zm-2 1a1 1 0 100-2 1 1 0 000 2zm-.625-5.22a1 1 0 011.25 0l1.874 1.5A4 4 0 0116 7.403v3.386a5 5 0 00.84 2.773l.656.985A3 3 0 0118 16.211V18H6v-1.789a3 3 0 01.504-1.664l.656-.985A5 5 0 008 10.79V7.403A4 4 0 019.501 4.28l1.874-1.5zm2.5-1.561a3 3 0 00-3.75 0L8.253 2.718A6 6 0 006 7.403v3.386a3 3 0 01-.504 1.664l-.656.985A5 5 0 004 16.21V18a2 2 0 002 2h12a2 2 0 002-2v-1.789a5 5 0 00-.84-2.773l-.656-.985A3 3 0 0118 10.789V7.403a6 6 0 00-2.252-4.685l-1.874-1.5z"}})])
          )
        }
      }
    